import { PlayerStatsResponse } from './player-stats.model';

/**
 * Walks `{ data }` / `{ body }` wrappers until a /stats payload is found.
 * Live responses sometimes nest `career_summary` one level deeper than the contract.
 */
export function pickPlayerStatsPayload(value: unknown, depth = 0): PlayerStatsResponse | null {
  if (!value || typeof value !== 'object' || depth > 3) {
    return null;
  }
  const record = value as Record<string, unknown>;
  if (hasStatsShape(record)) {
    return record as unknown as PlayerStatsResponse;
  }
  return pickPlayerStatsPayload(record['data'] ?? record['body'], depth + 1);
}

function hasStatsShape(record: Record<string, unknown>): boolean {
  return 'career_summary' in record
    || 'careerSummary' in record
    || 'performance_rates' in record
    || 'performanceRates' in record;
}
